import { useNavigate } from 'react-router-dom';
import { FaPalette } from 'react-icons/fa6';
import { Tooltip } from 'react-tooltip';
import { useId } from 'react';

const CustomizeButton = ({ link, className, targetTab, 'aria-label': ariaLabel }) => {
  const tooltipId = useId();
  const navigate = useNavigate();

  const handleClick = () => {
    // If targetTab is provided, add it as a query parameter
    const url = targetTab ? `${link}?tab=${targetTab}` : link;
    navigate(url);
  };

  return (
    <>
      <button 
        type="button"
        className={`${className} rounded-md focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-teal-500`}
        onClick={handleClick}
        data-tooltip-id={tooltipId}
        data-tooltip-content={ariaLabel}
        aria-label={ariaLabel}
      >
        <FaPalette size={20} color="#68C7CC" />
      </button>
      <Tooltip id={tooltipId} place="top" effect="solid" />
    </>
  );
};

export default CustomizeButton;
